import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// .Ambassador - Get All (Read)
// export const GetAll = createAsyncThunk(
//   "masters/ambassador_wallet/get-all",
//   async (filter, { rejectWithValue }) => {
//     try {
//       const res = await GET(
//         `${APIS.Masters.Ambassador}?name=${filter?.name ||
//           ""}&contact_no=${filter?.contact_no || ""}&page=${filter?.page ||
//           IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}${
//           filter?.is_active ? `&is_active=${filter.is_active}` : ""
//         }`
//       );
//       return res;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// Updated Slice.js - GetAll thunk only
export const GetAll = createAsyncThunk(
  "masters/ambassador_wallet/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      let query = `${APIS.Masters.Ambassador_Wallet}?name=${filter?.name ||
        ""}&contact_no=${filter?.contact_no || ""}&page=${filter?.page ||
        IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`;

      if (filter?.is_active !== undefined) {
        query += `&is_active=${filter.is_active}`;
      }
      if (filter?.user_status_id) {
        query += `&user_status_id=${filter.user_status_id}`;
      }
      if (filter?.login_status !== undefined) {
        query += `&login_status=${filter.login_status}`;
      }
      if (filter?.status !== undefined) {
        query += `&status=${filter.status}`;
      }

      const res = await GET(query);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const addMoney = createAsyncThunk(
  "admin/ambassador-wallet/add-amount",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.Masters.Ambassador_Wallet}/add-amount/${id}`,
        data,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const reduceMoney = createAsyncThunk(
  "admin/manage-wallet/reduce-amount",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.Masters.Ambassador_Wallet}/reduce-amount/${id}`,
        data,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// .Ambassador - Get (Read)
export const GetSingle = createAsyncThunk(
  "masters/ambassador_wallet/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Ambassador_Wallet}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// .Ambassador - Create (Add)
export const Create = createAsyncThunk(
  "masters/ambassador_wallet/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.Ambassador_Wallet, data);

      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// .Ambassador - Update
export const Update = createAsyncThunk(
  "masters/ambassador_wallet/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.Ambassador_Wallet}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// .Ambassador - Update
export const Status = createAsyncThunk(
  "masters/ambassador_wallet/update-status",
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Ambassador_Wallet}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const BlockStatus = createAsyncThunk(
  "masters/ambassador_wallet/update-block-status",
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.Masters.Ambassador_Wallet}/block-status/${id}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// .Ambassador - Delete
export const Delete = createAsyncThunk(
  "masters/ambassador_wallet/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.Ambassador_Wallet}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const UpdateUserStatus = createAsyncThunk(
  "masters/ambassador_wallet/update-user-status",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.Masters.Ambassador_Wallet}/update-user-status/${id}`,
        data,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetPickupDropFromAmbassador = createAsyncThunk(
  "masters/ambassador_wallet/get-pickup-drop-from-ambassador",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Ambassador_Wallet}/get-pickdrop-from-ambassador/${id}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const UpdateUserCharges = createAsyncThunk(
  "masters/ambassador_wallet/update-user-charges",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.Masters.Ambassador_Wallet}/update-user-charges/${id}`,
        data,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const Slice = createSlice({
  name: "ambassasor-wallet",
  initialState: {
    data: [],
    pick_drop_data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetPickupDropFromAmbassador.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetPickupDropFromAmbassador.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.pick_drop_data = action.payload || [];
      })
      .addCase(GetPickupDropFromAmbassador.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (property) => property.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateUserStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateUserStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (property) => property.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateUserStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateUserCharges.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateUserCharges.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (property) => property.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateUserCharges.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (property) => property.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(BlockStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(BlockStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (property) => property.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(BlockStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (property) => property.id !== action.payload,
        );
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(addMoney.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(addMoney.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
        // state.data.unshift(action.payload.data);
      })
      .addCase(addMoney.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(reduceMoney.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(reduceMoney.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
        // state.data.unshift(action.payload.data);
      })
      .addCase(reduceMoney.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
